import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/@pamperedchef+design-system@4.1.9_@react-aria+button@3.13.3_@react-spectrum+provider@3.11.1_r_avg64722ww422zfiqui2ywkuou/node_modules/@pamperedchef/design-system/design-system.css");
;
import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.7_@playwright+test@1.61.1_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.101.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["MotionConfig"] */ "/microservice/src/app/components/client/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsManager"] */ "/microservice/src/app/components/shared/analytics-manager/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/microservice/src/app/components/shared/error-boundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserManager"] */ "/microservice/src/app/components/shared/user-manager/client.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/styles/main.scss");
